import { Box, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Icon } from '@main/complykit/components/icon';

export interface FileProcessingWarningProps {
  label: string;
  variant?: 'compact' | 'attachment-card';
}

export function FileProcessingWarning({ label, variant = 'compact' }: FileProcessingWarningProps) {
  /* The tile keeps its hand-tuned orange rather than the warning role tokens;
   * the icon reads it through currentColor. */
  const tileBackground = useColorModeValue('orange.100', 'orange.900');
  const iconColor = useColorModeValue('orange.700', 'orange.200');
  const focusRingColor = useColorModeValue('blue.500', 'blue.200');
  const isAttachmentCard = variant === 'attachment-card';

  return (
    <Tooltip label={label} placement="top" hasArrow gutter={12} fontSize="sm" openDelay={500}>
      <Box
        as="span"
        role="img"
        aria-label={label}
        tabIndex={0}
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        minW={isAttachmentCard ? 7 : 5}
        w={isAttachmentCard ? 7 : 5}
        h={isAttachmentCard ? 7 : 5}
        p={isAttachmentCard ? 1.5 : 1}
        bg={tileBackground}
        color={iconColor}
        flexShrink={0}
        lineHeight={0}
        rounded="base"
        cursor="help"
        _focusVisible={{
          outline: '2px solid',
          outlineColor: focusRingColor,
          outlineOffset: '2px',
        }}
      >
        <Icon as={ExclamationTriangleIcon} size={isAttachmentCard ? 'md' : 'sm'} />
      </Box>
    </Tooltip>
  );
}
